import './ProgessBar.scss';
import { connect } from 'react-redux';
import { getCurrentStep } from 'state/steps/StepSelectors';
import React, {
  useEffect,
  useState,
} from 'react';
import {
  object,
  string,
} from 'prop-types';

export const ProgressBar = ({ currentStep, progressBarSteps, icon }) => {
  const allSteps = progressBarSteps.map((step) => {
    if (step && step.stepValues && step.stepValues.includes(currentStep)){
      return <ProgressStep key={step.name}
                           stepName={step.name}
                           statusType="current"
                           sizeOfArray={step.stepValues.length}
                           currentStep={currentStep}
                           indexOfElement={step.stepValues.indexOf(currentStep)}/>;
    } else if (currentStep > step.stepValues.sort((a, b) => {
      return a - b;
    })[step.stepValues.length - 1]) {
      return <ProgressStep key={step.name}
                           stepName={step.name}
                           icon={icon}
                           currentStep={currentStep}
                           statusType="completed"/>;
    }

    if (step.name){
      return <ProgressStep key={step.name}
                           currentStep={currentStep}
                           stepName={step.name}/>;
    }
  });
  return (
    <>
      {currentStep > 6
        ? <></>
        : <div className="progress-bar"
               aria-label='progress'>
        {allSteps}
      </div>
      }
      <div className="progress-bar-title-phone">{progressBarSteps.find(x=>x.stepValues.includes(currentStep))?.name}</div>
    </>
  );
};

export const ProgressStep = ({ stepName, statusType, sizeOfArray, indexOfElement, icon, currentStep }) => {
  const [percentageFill, setPercentageFill] = useState(0);
  const isMobile = () =>
    window.matchMedia('screen and (max-width: 767px)')
      ? true
      : false;
  useEffect(() => {
    setPercentageFill(((indexOfElement+1)/sizeOfArray) * 100)
  }, [indexOfElement, sizeOfArray]);
  
  const progressValue = (step) => {
    var value;
    if (step === 0 || step === 1) {
      value = 0;
    } else if (step === 6) {
      value = 100;
    } else {
      value = (step -1) * 20;
    }
    return value.toString();
  };

  return (
    <div role="progressbar"
         className="progress-bar-components"
         aria-current={statusType === 'current'}
         aria-label={stepName}
         aria-valuenow={progressValue(currentStep)}
      >
      <div className={`progress-bar-title progress-bar-title-${statusType}`}>
        {icon && (
          <span className={
              currentStep === 6
                ? 'icon-withBarTitle-review'
                : 'icon-withBarTitle'
            }
          >
            {icon}
          </span>
        )}
        <span aria-label={stepName}
              className='step-title' >
          {stepName}
        </span>
      </div>
      <div className={`progress-bar-bar progress-bar-bar-${statusType}`}
           style={
              statusType === 'current'
                ? {
                    background: `linear-gradient(90deg, #086EA1 0 ${percentageFill}%, #D3D7DA ${percentageFill}% 100%)`,
                  }
                : currentStep === 6 && isMobile()
                ? { background: '#248647' }
                : null
            }
      />
    </div>
  );
};

ProgressStep.propTypes = {
  stepName: string.isRequired,
  statusType: string,
  icon: object,
};

ProgressStep.defaultProps = {
  stepName: '',
  statusType: 'default',
  icon: null,
};

const mapStateToProps = state => ({
  currentStep: getCurrentStep(state),
});
export default connect(mapStateToProps)(ProgressBar);